// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3vhQ_","productName":"Table_productName__31IOk"};